import { render, staticRenderFns } from "./secVideo4.vue?vue&type=template&id=a03b8864&scoped=true&"
var script = {}
import style0 from "./secVideo4.vue?vue&type=style&index=0&id=a03b8864&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03b8864",
  null
  
)

export default component.exports